module.exports = __webpack_public_path__ + "img/money-in-hand.e3dda5e8.png";